import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { cn } from '@shared/utils';
import { Transactions } from './widgets';
import type { IFilter } from '@pages';
import { AccountsSlider } from '@widgets';
import { DatePicker, ItemsType, Select } from '@shared/widgets';

const FILTER_OPTIONS = [
  { leftLabel: 'ALL', value: 'All' },
  { leftLabel: 'PAID IN', value: 'PaidIn' },
  { leftLabel: 'PAID OUT', value: 'PaidOut' },
];

const getFilterFromQueryParams = (): IFilter => {
  const query = new URLSearchParams(location.search);
  const from = query.get('from') ? dayjs.utc(query.get('from'), 'MM-DD-YYYY').toDate() : null;
  const to = query.get('to') ? dayjs.utc(query.get('to'), 'MM-DD-YYYY').toDate() : null;

  return { searchQuery: query.get('q') || '', dateFilter: { from, to } };
};

export const AccountsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [filter, setFilter] = useState<IFilter>(getFilterFromQueryParams());
  const [selectedOption, setSelectedOption] = useState<ItemsType>();

  const handleDateFilter = (dateFilter: { from: Date | null; to: Date | null }) => {
    setFilter((prev) => ({ ...prev, dateFilter }));
    const newQuery = new URLSearchParams(location.search);
    dateFilter.from ? newQuery.set('from', dayjs.utc(dateFilter.from).format('MM-DD-YYYY')) : newQuery.delete('from');
    dateFilter.to ? newQuery.set('to', dayjs.utc(dateFilter.to).format('MM-DD-YYYY')) : newQuery.delete('to');
    navigate(`${location.pathname}?${newQuery.toString()}`);
  };

  return (
    <div className={cn('page-animation', 'pt-7')}>
      <div className='mx-auto my-0 w-full max-w-[1294px] px-5'>
        <div>
          <div className={cn('relative mx-2 text-xl font-bold text-[#f2f2f2] uppercase', 'not-md:text-base')}>
            <span className='absolute top-0 -left-3 font-semibold text-[#a73f33]'>/</span>
            Accounts
          </div>
        </div>
        <AccountsSlider accountsPage />
        <div className={cn('mb-7 flex items-center justify-between', 'max-sm:block')}>
          <div className={cn('mr-7 h-[50px] w-[245px]', 'max-sm:mb-5')}>
            <Select placeholder='FILTER BY:' items={FILTER_OPTIONS} value={selectedOption?.value} onChange={setSelectedOption} />
          </div>
          <DatePicker range={{ ...filter.dateFilter }} onConfirm={handleDateFilter} />
        </div>
        <Transactions selectedOptions={selectedOption!} dateFilter={filter.dateFilter} />
      </div>
    </div>
  );
};
